import { InfoPanel, Paragraph, Section } from '@axinom/mosaic-ui';
import React from 'react';

export interface DetailsInfoPanelProps {
  tenantId: string;
  environmentId: string;
  updatedAt: string;
  updatedBy: string;
}

export const DetailsInfoPanel: React.FC<{
  infoPanelData: DetailsInfoPanelProps | undefined;
}> = ({ infoPanelData }) => {
  return (
    <InfoPanel>
      <Section>
        <Paragraph title="Last Modified">
          {infoPanelData
            ? `${new Date(infoPanelData.updatedAt).toLocaleString()} by ${
                infoPanelData.updatedBy
              }`
            : ''}
        </Paragraph>
      </Section>
      <Section>
        <Paragraph title="Tenant ID">{infoPanelData?.tenantId}</Paragraph>
        <Paragraph title="Environment ID">
          {infoPanelData?.environmentId}
        </Paragraph>
      </Section>
    </InfoPanel>
  );
};
